import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tenantPractitioner: {},
  tenantOrganization: {},
  currentPatientObject: {},
  currentPractitionerObject: {},
  currentTempPatientImageArray: [],
  currentClaimsObject: {},
  currentDiagnosisInClaims: [],
  currentDiagnosisInClaimsCount: 0,
  currentProceduresInClaims: [],
  currentCPTModifierLists: [],
  currentModifierCPT: 0,
  currentPractitionerLocations: [],
  beneficiaries: [],
  relatedpersonObject: {},
  currentEncounter: {},
  currrentEncounterObject: {},
  currentPagePersistanceState: {
    encounterListView: true,
    encounterPersistanceObject: {
      listView: true,
      currentState: null,
    },
  },
  loggedInUserData: {},
  permissions: {},
  getLoggedInUserData: new Function(),
  currentUserSettings: {},
  currentUserDashboardSettings: {},
  currentUserFrequentlyUsedCodes: {},
  licenses: [],
  backupData: {},
};

const currentSlice = createSlice({
  name: 'currentSlice',
  initialState,
  reducers: {
    clearOrganization: state => {
      state.tenantOrganization = [];
    },

    setTenantOrganization: (state, action) => {
      state.tenantOrganization = action?.payload;
    },

    setTenantPractitioner: (state, action) => {
      state.tenantPractitioner = action?.payload;
    },

    setReduxCurrentPatientObject: (state, action) => {
      state.currentPatientObject = action?.payload;
    },

    setReduxCurrentPractitionerObject: (state, action) => {
      state.currentPractitionerObject = action?.payload;
    },

    setReduxCurrentClaimsObject: (state, action) => {
      state.currentClaimsObject = action?.payload;
    },
    setReduxCurrentProceduresObject: (state, action) => {
      state.currentProceduresInClaims = action?.payload;
      state.currentDiagnosisInClaimsCount =
        state.currentDiagnosisInClaimsCount + 1;
    },
    setReduxCurrentDiagnosisObject: (state, action) => {
      state.currentDiagnosisInClaims = action?.payload;
      state.currentDiagnosisInClaimsCount =
        state.currentDiagnosisInClaimsCount + 1;
    },
    setReduxRelatedPersonObject: (state, action) => {
      state.relatedpersonObject = action?.payload;
    },
    setCPTModifiersInProcedures: (state, action) => {
      let modifierLists = [...state.currentCPTModifierLists];
      if (modifierLists.some(s => s.index === action.payload.rowIndex)) {
        modifierLists[
          modifierLists.findIndex(f => f.index === action.payload.rowIndex)
        ].modifierList = action.payload.modifiers;
      } else {
        modifierLists.push({
          index: action.payload.rowIndex,
          modifierList: action.payload.modifiers,
        });
      }
      state.currentCPTModifierLists = [...modifierLists];
      state.currentModifierCPT = state.currentModifierCPT + 1;
    },
    setAllBeneficiaries: (state, action) => {
      state.beneficiaries = action.payload.data;
    },

    setCurrentEncounter: (state, action) => {
      state.currentEncounter = action?.payload;
    },

    setCurrentEncounterObject: (state, action) => {
      state.currrentEncounterObject = action?.payload;
    },

    setCurrentPagePersistanceState: (state, action) => {
      state.currentPagePersistanceState = action?.payload;
    },

    setCurrentPractitionerLocations: (state, action) => {
      state.currentPractitionerLocations = action?.payload;
    },

    setCurrentLoggedInUserData: (state, action) => {
      state.loggedInUserData = action?.payload;
    },
    clearLoggedInUserData: (state, action) => {
      state.loggedInUserData = {};
    },
    setPermissions: (state, action) => {
      state.permissions = action?.payload;
    },
    setRoleAndLicenseHelperFunction: (state, action) => {
      state.getLoggedInUserData = action?.payload;
    },
    setCurrentUserSettings: (state, action) => {
      state.currentUserSettings = action?.payload;
    },
    setCurrentDashboardSettings: (state, action) => {
      state.currentUserDashboardSettings = action?.payload;
    },
    setCurrentUserFrequentlyUsedCodes: (state, action) => {
      state.currentUserFrequentlyUsedCodes = action?.payload;
    },
    setLicensesData: (state, action) => {
      state.licenses = action?.payload;
    },
    setBackupData: (state, action) => {
      state.backupData = action?.payload;
    },

    setCurrentTempPatientImageArray: (state, action) => {
      state.currentTempPatientImageArray = action?.payload;
    },
  },
});

export const {
  setReduxCurrentPatientObject,
  setReduxRelatedPersonObject,
  setReduxCurrentPractitionerObject,
  setReduxCurrentClaimsObject,
  setReduxCurrentProceduresObject,
  setReduxCurrentDiagnosisObject,
  setCPTModifiersInProcedures,
  setAllBeneficiaries,
  setTenantOrganization,
  setCurrentEncounter,
  setCurrentPagePersistanceState,
  setCurrentEncounterObject,
  setCurrentPractitionerLocations,
  clearOrganization,
  setCurrentLoggedInUserData,
  clearLoggedInUserData,
  setPermissions,
  setRoleAndLicenseHelperFunction,
  setCurrentUserSettings,
  setCurrentDashboardSettings,
  setCurrentUserFrequentlyUsedCodes,
  setLicensesData,
  setTenantPractitioner,
  setBackupData,
  setCurrentTempPatientImageArray,
} = currentSlice.actions;
export default currentSlice.reducer;
